<template>
  <v-row class="px-4 pt-3 pb-4 details-proposal__card-auto">
    <v-col cols="12">
      <p class="primary--text font-weight-bold mb-2">
        Coberturas:
      </p>
    </v-col>
    <v-col cols="12" class="details-proposal__item-auto">
      <v-row class="px-4 py-6">
        <v-col cols="12" md="6">
          <p v-if="form.granizo > 0"
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Granizo:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.granizo) }}
            </label>
          </p>
          <p v-if="form.granizo_geada > 0"
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Granizo e Geada:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.granizo_geada) }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Perda Produção Futura:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.perda_producao_futura) }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Tratamento Fitossanitário:
            <label class="details-proposal__value primary--text">
              {{ asMoneyString(form.tratamento_fitossanitario) }}
            </label>
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import DocumentsMixin from "@/mixins/DocumentsMixin";
import { asMoneyString } from "@/utils/formats.js";

export default {
  name: "QuotationProposalAgricolaInformation",
  mixins: [DocumentsMixin],
  data() {
    return {
      asMoneyString
    };
  },
  computed: {
    hasAditionalCoverage() {
      return this.form.tipo_cobertura?.id === "basica_replantio";
    }
  },
  props: {
    form: {
      type: Object
    },
    isPolicy: {
      type: Boolean,
      default: false
    }
  }
};
</script>
